import { jwtDecode } from "jwt-decode";
import { axiosEduServer } from "../utils/configAxios";
export const login = (dataU) => {
  return axiosEduServer.post("/auth/User/login", dataU).then(({ data }) => {
    const decoded = jwtDecode(data.token);
    const userInfo = {
      rol: decoded.role,
      id: data.id,
      username: data.username,
      token: data.token,
      nombre: data.nombre,
      apellido: data.apellido
    }
    return userInfo;
  }).catch((err) => { throw err });
}

export async function cambiarContrasena(data) {
  return await axiosEduServer.put("/auth/User", data).then(({ data }) => data).catch((err) => { throw err })
}